import React from 'react';
import { iconSize } from '../../../constants/icon.constants';
import { getThumbnailProps } from '../../../utils/youtubeUtils';
import Picture from '../../@shared/picture';
import { TContentHubImageProps } from '../../@shared/picture/types/contentHubImage.types';
import VideoPlayer from '../../@shared/videoPlayer';
import { ProductSeriesDetailTestimonialModel } from '../models/productSeriesDetailTestimonial.model';

const TestimonialMedia = ({ model }: { model: ProductSeriesDetailTestimonialModel }) => {
  if (model.asset && model.mediaData.type === 'image') {
    return (
      <Picture
        productImageProps={{
          desktopRendition: model.asset.rendition_desktop_size1000,
          mobileRendition: model.asset.rendition_mobile_size500,
          imageClassName: 'product-series-testimonial__image',
        }}
      />
    );
  }

  if (model.asset && (model.mediaData.type === 'video' || model.mediaData.type === 'extvideo')) {
    const { thumbnailImgSrc } = getThumbnailProps(model.mediaData.link || '');

    const videoThumbnail: TContentHubImageProps =
      model.mediaData.type === 'extvideo'
        ? { desktopRendition: { url: thumbnailImgSrc } }
        : {
            mobileRendition: { url: model.asset.bigthumbnail },
            alt: model.asset?.alt,
          };

    return (
      <div className="product-series-testimonial__video-wrapper">
        <div className="product-series-testimonial__video--external">
          <VideoPlayer
            link={model.mediaData.link?.replace('sitecore/media-library', '-/media')}
            showThumbnail={true}
            productImageProps={videoThumbnail}
            mediaTitle={model?.mediaTitle}
            mobilePlayIconSize={iconSize.xlg}
            useAnalytics={true}
            controls={true}
            autoPlay={true}
            className={'slide__video'}
          />
        </div>
      </div>
    );
  }

  return null;
};

export default TestimonialMedia;
